module.exports = __webpack_public_path__ + "static/kf-section-bg-mobile-5a5038e01f26d8a5a8e1313e927d0016.jpg";